export function getCurrentYearNumber(): number {
  const currentDate = new Date();
  return currentDate.getFullYear();
}
